import { render, staticRenderFns } from "./SidebarAddNewCustomer.vue?vue&type=template&id=fe403e08&"
import script from "./SidebarAddNewCustomer.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports